// src/components/screener/ScoreRing.jsx
// Extracted from ScreenerPage.jsx (SCREENER-FRAG) — content unchanged, location only.

import React from 'react';
import { S } from '../../constants/screenerConfig';
import { signalColor } from '../../lib/screenerFormatters';

// ── Score ring: small circular indicator ─────────────────────
export default function ScoreRing({ score, signal }) {
  const r   = 14;
  const circ = 2 * Math.PI * r;
  const fill = (score / 100) * circ;
  const col  = signalColor(signal);
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" style={{ flexShrink: 0 }}>
      <circle cx="18" cy="18" r={r} fill="none" stroke={S.border2} strokeWidth="3" />
      <circle cx="18" cy="18" r={r} fill="none" stroke={col} strokeWidth="3"
        strokeDasharray={`${fill} ${circ}`}
        strokeLinecap="round"
        transform="rotate(-90 18 18)"
      />
      <text x="18" y="22" textAnchor="middle" fontSize="9" fill={col} fontWeight="700"
        fontFamily="monospace">
        {score}
      </text>
    </svg>
  );
}
